@if (taskHistoryIsLoading$ | async) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
@if (taskHistory$ | async; as taskHistory) {
  @if (taskHistory.length === 0) {
    <p class="no-history">No history found.</p>
  }

  <ul class="history-list">
    @for (item of taskHistory; track $index) {
      <li class="history-item">
        <div class="history-details">
          <div class="history-message">
            <span class="history-person">{{ (item.changed_by | shortId) ?? 'Unknown' }}</span>
            {{ item | taskHistoryDisplay }}
          </div>
          <div class="history-metadata">
            <span [title]="item.changed_by?.id" class="actor-type"
              >({{ item.changed_by?.type ? (item.changed_by?.type | titlecase) : 'Unknown' }})</span
            >
            <span class="timestamp">at {{ +item.created_at * 1000 | date: 'MMM d, y, h:mm a' }}</span>
          </div>

          <details *ngIf="item.change_type === 'updated' && item.changes">
            <summary>Details of Changes</summary>
            <ul class="change-details">
              @for (changeKey of item.changes | keyvalue; track $index) {
                @if (changeKey.value.old !== changeKey.value.new) {
                  <li>
                    <span class="change-key">{{ changeKey.key | titlecase }}:</span>
                    <span class="old-value">"{{ changeKey.value.old }}"</span>
                    &rarr;
                    <span class="new-value">"{{ changeKey.value.new }}"</span>
                  </li>
                }
              }
            </ul>
          </details>
        </div>
      </li>
    }
  </ul>
}
